import React from "react";
import { CalendarIconSVG } from "../../../../assets/auth/NavbarIconsSVG";
import { useIntl } from "react-intl";
import { FaCalendarDays } from "react-icons/fa6";
import { LuCalendarCheck2 } from "react-icons/lu";
type Props = {
  step: number;
};
export default function ModalHeader({ step }: Props) {
  const intl = useIntl();
  return (
    <div className="flex flex-col justify-center items-center gap-2 my-2">
      <div>
        {step < 5 ? (
          <FaCalendarDays size={30} />
        ) : (
          <LuCalendarCheck2 size={30} color="#479821" />
        )}
      </div>
      <div>
        <p
          className={
            step < 5
              ? "text-semibold text-lg"
              : "text-semibold text-lg text-[#479821]"
          }
        >
          {step < 5
            ? intl.formatMessage({
                id: "addNewAppointment",
                defaultMessage: "اضافة حجز جديد",
              })
            : intl.formatMessage({
                id: "appointmentAdded",
                defaultMessage: " تم اضافة الحجز !",
              })}
        </p>
      </div>
    </div>
  );
}
